import { Component, ViewChild } from '@angular/core';
import { MakeProvider } from '../abstract-custom-control';
import { AuthenticationService } from '../../base-services/authentication.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { InputComponent } from '../input/input/input.component';

@Component({
    selector: 'yt-login-v2',
    templateUrl: './login-v2.component.html',
    providers: [MakeProvider(LoginV2Component)]
})
export class LoginV2Component{
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router
    ){
    }

    loginFormGroup: FormGroup = new FormGroup({
        Username: new FormControl('', Validators.required),
        Password: new FormControl('', Validators.required)
    });

    loginSubmitted: boolean = false;
    loggingIn: boolean = false;

    showStatus: boolean = false;
    statusText: string = '';
    capsLockMessage: string;

    @ViewChild('username', { static: true }) username: InputComponent;
    @ViewChild('password', { static: true }) password: InputComponent;

    ngAfterViewInit(){
        setTimeout(() => {
            if(this.username){
                this.username.focus();
            }
        }, 100)

        const eventHandler = (event: KeyboardEvent | MouseEvent) => {
            if(event.type === 'keyup' && !(event instanceof KeyboardEvent)){
                return;
            }
            if(event.getModifierState('CapsLock')){
                this.capsLockMessage = 'CAPS-LOCK-ON';
            }
            else{
                this.capsLockMessage = undefined;
            }
        };

        this.password.inputControl.nativeElement.addEventListener('keyup', eventHandler);
        this.password.inputControl.nativeElement.addEventListener('mousedown', eventHandler);
    }

    ngOnDestroy(){
        this.password.inputControl.nativeElement.removeAllListeners('keyup');
        this.password.inputControl.nativeElement.removeAllListeners('mousedown');
    }

    Login(username, password){
        this.loginSubmitted = true;
        if(this.loginFormGroup.valid){
            this.loggingIn = true;
            this.authenticationService.Login(username, password)
                .subscribe(data => {
                    this.router.navigate(['/company-selector']);
                }, error => {
                    this.showStatus = true;
                    //this.statusText = 'FW.ERRORS.' + (error.error.error == 'invalid-grant' ? 'INVALID-GRANT' : 'ERROR');
                    //this.statusText = 'FW.ERRORS.' + (error.error.error ? error.error.error.toString().toUpperCase() : 'ERROR');
                    this.statusText = 'FW.ERRORS.' + (error.error.error ? this.getMessage(error.error.error.toString()) : 'ERROR')
                    this.loggingIn = false;
                })
        }
    }

    private getMessage(error: string){
        if(error.indexOf('_') > -1){
            error = error.replace('_', '-');
        }

        return error.toUpperCase();
    }
}